<template>
  <div class="form-wrapper">
    <h2>Add Unit</h2>
    <form @submit.prevent="submitForm">
      <div class="form-group">
        <label>Name</label>
        <input v-model="unit.name" type="text" required placeholder="Unit Name" />
      </div>
      <div class="form-group">
        <label>Status</label>
        <select v-model="unit.status">
          <option>Active</option>
          <option>Inactive</option>
        </select>
      </div>
      <button type="submit" class="btn btn-gradient">
        <span v-if="loading">Saving...</span>
        <span v-else>Save Unit</span>
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'AddUnitComponent',
  data() {
    return {
      unit: { name: '', status: 'Active' },
      loading: false,
    };
  },
  methods: {
    submitForm() {
      this.loading = true;
      this.$store.dispatch('units/addUnit', this.unit)
        .then(() => this.$router.push({ name: 'Units' }))
        .finally(() => this.loading = false);
    }
  }
};
</script>
